import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClipboardPermissionService {
  private permissionChecked = false;
  public canReadClipboard = false;

  async checkPermission(): Promise<boolean> {
    if (!this.permissionChecked) {
      try {
        await navigator.clipboard.readText();
        this.canReadClipboard = true;
      } catch (e: any) {
        console.log('Clipboard access denied:', e);
        this.canReadClipboard = false;
      }
      this.permissionChecked = true;
    }
    return this.canReadClipboard;
  }

  async copyFromClipboard() {
    return this.canReadClipboard ? (await navigator.clipboard.readText())?.trim() : '';
  }
}
